import { render, staticRenderFns } from "./DialogoTerminarVenta.vue?vue&type=template&id=62274038&scoped=true&"
import script from "./DialogoTerminarVenta.vue?vue&type=script&lang=js&"
export * from "./DialogoTerminarVenta.vue?vue&type=script&lang=js&"
import style0 from "./DialogoTerminarVenta.vue?vue&type=style&index=0&id=62274038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62274038",
  null
  
)

export default component.exports